module.exports = __webpack_public_path__ + "static/Roger Fatah-3439d71eb2033a595f41fa3b07374b92.jpg";